// 引数の`obj`をシャローコピーしたオブジェクトを返す
const shallowClone = (obj: any): any => ({ ...obj });

// 引数の`obj`をディープコピーしたオブジェクトを返す
const deepCopyObj = (obj: object): object => {
  const newObj = shallowClone(obj);
  // プロパティがオブジェクト型であるなら、再帰的に複製する
  Object.keys(newObj)
    .filter((key) => typeof newObj[key] === 'object')
    .forEach((key) => {
      newObj[key] = deepCopyObj(newObj[key]);
    });
  return newObj;
};

export { deepCopyObj };
